import styled, { keyframes } from 'styled-components';

export const TinyLoadingIndicator = styled.div`
  width: 0.8rem;
  height: 0.8rem;
  border: 0.125rem solid ${({ theme }) => theme.palette.foreground.primary};
  border-left-color: transparent;
  border-radius: 50%;
  box-sizing: border-box;
  animation-name: ${keyframes`
    0% {
      transform: rotate3d(0, 0, 1, 0deg)
    }
    100% {
      transform: rotate3d(0, 0, 1, 360deg)
    }
  `};
  animation-iteration-count: infinite;
  animation-duration: 1s;
  animation-timing-function: linear;
`;
